module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"prolongationFailed":"Последняя попытка продления подписки была безуспешной","prolongSubscription":"Продлить подписку"}}')
  delete Component.options._Ctor
}
